import React from "react";
import { DollarSign, TrendingDown, TrendingUp } from "lucide-react";

const totalAssets = 3670000;
const totalLiabilities = 2310000;
const netAssetValue = totalAssets - totalLiabilities;

const AssetBasedApproach = () => {
  return (
    <div className="bg-white p-6 rounded-2xl shadow mb-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4 flex items-center gap-2">
        <DollarSign className="text-blue-500" /> Asset-Based Approach
      </h3>
      <p className="text-gray-600">
        The Asset-Based Approach values the business based on its total assets and liabilities.
      </p>
      <div className="mt-4 space-y-2">
        <p className="flex items-center gap-2 text-gray-800 font-semibold">
          <TrendingUp className="text-green-500" /> Total Assets (2024): <span className="text-black">${totalAssets.toLocaleString()}</span>
        </p>
        <p className="flex items-center gap-2 text-gray-800 font-semibold">
          <TrendingDown className="text-red-500" /> Total Liabilities (2024): <span className="text-black">${totalLiabilities.toLocaleString()}</span>
        </p>
      </div>

      <div className="mt-4 p-4 bg-gray-100 rounded-lg">
        <h3 className="text-lg font-semibold">Net Asset Value (NAV) Estimate:</h3>
        <p className="text-gray-800 font-bold">
          ${netAssetValue.toLocaleString()}
        </p>
      </div>

      <p className="mt-4 text-gray-600">
        This method provides a lower bound valuation, as it does not factor in future earnings potential.
      </p>
    </div>
  );
};

export default AssetBasedApproach;